import React, { useState, useEffect } from "react";

// `loading` and `decoding` are optional and default to undefined, so a caller that does not pass them
// renders exactly the <img> this component has always rendered. The legacy club-search list passes
// loading="lazy" because it renders every club at once (~900 logos) inside fixed-size boxes.
const ImageWithFallback = ({ src, fallbackSrc, alt, loading, decoding }) => {
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  const handleError = () => {
    setImgSrc(fallbackSrc);
  };

  return <img src={imgSrc} alt={alt} onError={handleError} className="fit-extend-selector-img" loading={loading} decoding={decoding} />;
};

export default ImageWithFallback;
